import React, { useState } from "react";

type State = {
    parameterName: string;
    parameterValue: string;
}

export const useNewInputDialog = () => {
    const [state, setState] = useState<State>({ parameterName: "", parameterValue: "" });
    
    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setState((prevState) => ({
            ...prevState,
            [event.target.name]: event.target.value
        }));
    }

    const onCleanForm = () => {
        setState({ parameterName: "", parameterValue: "" });
    }

    return {
        state,
        onChange,
        onCleanForm
    }
}